import { AsyncPipe, DecimalPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetClassOverviewFacade } from '@zero/asset-class-overview/domain';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { IconButtonComponent, IconComponent, TabNavigationComponent } from '@zero/shared/ui-web-design-system';
import { InstrumentType, TabNavigationModel } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { NgArrayPipesModule } from 'ngx-pipes';

@Component({
  selector: 'shared-winner-loser',
  imports: [
    TranslocoPipe,
    TranslocoPipe,
    TabNavigationComponent,
    IconButtonComponent,
    NgTemplateOutlet,
    DecimalPipe,
    NgClass,
    AsyncPipe,
    InstrumentDetailsLinkComponent,
    NgbTooltipModule,
    IconComponent,
    NgArrayPipesModule,
  ],
  templateUrl: './winner-loser.component.html',
  styleUrl: './winner-loser.component.scss',
})
export class WinnerLoserComponent implements OnInit {
  public readonly collapsed = signal<boolean>(false);
  public readonly tabModel = signal<TabNavigationModel>(undefined);
  public readonly activeTab = computed(() => this.tabModel().tabs.find((tab) => tab.active));
  public readonly instrumentType = input<InstrumentType>();
  public readonly facade = inject(AssetClassOverviewFacade);
  public readonly commonRoutes = commonRoutes;

  ngOnInit(): void {
    this.facade.loadWinnerLoser(this.instrumentType());
    this.tabModel.set({
      tabs: [
        { id: 'asset-class-overview.shared.winner-loser.winner', active: true },
        { id: 'asset-class-overview.shared.winner-loser.loser', active: false },
      ],
    });
  }

  public collapse = () => this.collapsed.update((collapsed) => !collapsed);

  public onTabChange = (tabId: string) =>
    this.tabModel.update((model) => ({ tabs: model.tabs.map((tab) => ({ ...tab, active: tab.id === tabId })) }));
}
